var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isConditionMet
    ? _c(
        "div",
        {
          style: "width: 100%; text-align: " + _vm.item.alignment,
          on: {
            click: function($event) {
              return _vm.$emit("click", $event)
            }
          }
        },
        [
          _c("img", {
            staticClass: "mx-brand-logo",
            style: "width:" + _vm.item.width + "px",
            attrs: { alt: "Business logo", src: _vm.logoUrl }
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }